const React = require('react')
const Layout = require('./src/components/Layout').default

require('~styles/app.scss')

// Wraps every page in a component
exports.wrapPageElement = ({ element, props }) => (
  <Layout {...props}>{element}</Layout>
)
